import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  color: ${COLORS.BLACK};
  padding: 30px 0;
`;
const Wrapper = styled.div`
  margin-right: auto;
  margin-left: auto;
  max-width: 1200px;
  width: 100%;
`;

const Heading = styled.h2`
  text-transform: uppercase;
  text-align: center;
  margin: 0 0 56px;
  font-size: 28px;
  line-height: 42px;
  @media (max-width: 1023.98px) {
    margin: 0 auto 38px;
    max-width: 70%;
    font-size: 21px;
    line-height: 28px;
  }
`;
const Separator = styled.div`
  display: block;
  width: 70px;
  height: 3px;
  background: #000;
  margin: 0 auto;
  position: relative;
  top: -32px;
  @media (max-width: 1023.98px) {
    top: -24px;
  }
`;

const CardWrapper = styled.div`
  &:focus {
    outline: none;
  }
`;

const Card = styled.div`
  background: #fff;
  display: grid;
  padding: 15px;
  border-radius: 4px;
  min-height: 240px;
  margin: 0 15px;
  &:focus {
    outline: 0;
  }
  div {
    &:first-child {
      display: flex;
      h3 {
        text-transform: uppercase;
        margin: 0;
        font-size: 24px;
        line-height: 36px;
      }
      h5 {
        color: #000;
        font-size: 18px;
        margin-top: 0;
        line-height: 27px;
        margin-bottom: 20px;
      }
      @media (max-width: 1023.98px) {
        h3 {
          font-size: 18px;
          line-height: 30px;
        }
        h5 {
          font-size: 18px;
          line-height: 24px;
        }
      }
    }
  }
  p {
    align-self: start;
    margin: 0;
    font-size: 16px;
    line-height: 24px;
    @media (max-width: 1023.98px) {
      font-size: 12px;
      line-height: 19px;
    }
  }
  img {
    align-self: start;
    margin-right: 2em;
    width: 100%;
    max-width: 100px;
    border-radius: 50%;
  }
  @media (min-width: 1024px) {
    min-height: 300px;
    border-radius: 4px;
  }
`;
const Review = styled.div``;

export { Container, Wrapper, Heading, Separator, Review, CardWrapper, Card };
